import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, createElementVNode as _createElementVNode, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = ["for"];
const _hoisted_2 = ["id"];
const _hoisted_3 = {
    key: 0,
    value: ""
};
const _hoisted_4 = ["value"];
import { $lang } from '@vue/services/utilities';
import TomSelect from 'tom-select';
import { computed, onMounted, ref, watch } from 'vue';
import 'tom-select/dist/css/tom-select.bootstrap5.min.css';
export default /*#__PURE__*/ _defineComponent({
    __name: 'SelectField',
    props: {
        name: {},
        options: {},
        labelField: { default: 'text' },
        valueField: { default: 'value' },
        label: {},
        labelClass: {},
        rules: {},
        prefix: { default: 'item' },
        inline: { type: Boolean, default: false },
        disabled: { type: Boolean, default: false },
        defaultValue: {},
        emptyOptions: { type: Boolean, default: false },
        clearWhenOptionsChange: { type: Boolean, default: false },
        sort: { type: Boolean, default: false },
        status: {}
    },
    emits: ['update'],
    setup(__props, { emit: __emit }) {
        const emits = __emit;
        const props = __props;
        const selector = ref();
        onMounted(() => {
            selector.value = new TomSelect('#' + getInputId.value, getTomSelectConfig());
        });
        watch(() => props.options, async (v) => {
            if (props.clearWhenOptionsChange) {
                await selector.value.clear();
                await selector.value.clearOptions();
                v.unshift({ text: $lang('app.reservation.placeholder.select'), value: '' });
                await addOptions(v);
                await selector.value.addItem('');
            }
            else {
                await selector.value.clearOptions();
                await addOptions(v);
            }
        }, {
            deep: true
        });
        watch(() => props.disabled, (v) => {
            if (v) {
                selector.value.disable();
            }
            else {
                selector.value.enable();
            }
        });
        const field = ref(props.defaultValue);
        watch(() => field.value, (v) => {
            emits('update', v);
        });
        const validateTooltipClass = ref();
        const getInputId = computed(() => {
            const name = props.name.replace(/\./g, '-');
            return 'input-' + props.prefix + '-' + name;
        });
        function changeValidateState(v) {
            if (v.inputClass) {
                selector.value?.wrapper.classList.add(v.inputClass);
            }
            else {
                selector.value?.wrapper.classList.remove('is-invalid');
            }
            validateTooltipClass.value = v.tooltipClass;
        }
        async function addOptions(v) {
            await selector.value.addOptions(v);
        }
        function getTomSelectConfig() {
            const config = getDefaultConfigs();
            if (props.sort) {
                config.sortField = [
                    {
                        field: "value",
                        direction: "asc"
                    }
                ];
            }
            return config;
        }
        function getDefaultConfigs() {
            return {
                create: true,
                wrapperClass: 'l-select-field__wrapper ts-wrapper form-select',
                controlClass: 'l-select-field__control ts-control',
                dropdownClass: 'l-select-field__dropdown ts-dropdown',
                dropdownContentClass: 'l-select-field__dropdown-content ts-dropdown-content',
                optionClass: 'option l-select-field__option',
                controlInput: undefined,
                allowEmptyOption: true
            };
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(_ctx.inline ? `d-md-flex align-items-center` : ``)
            }, [
                (_ctx.label)
                    ? (_openBlock(), _createElementBlock("label", {
                        key: 0,
                        class: _normalizeClass(["form-label h6 mb-3", [
                                _ctx.inline ? `mb-3 mb-md-0` : `mb-3`,
                                _ctx.labelClass ? _ctx.labelClass : ''
                            ]]),
                        for: getInputId.value
                    }, _toDisplayString(_ctx.label), 11, _hoisted_1))
                    : _createCommentVNode("", true),
                _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((field).value = $event)),
                    id: getInputId.value
                }, [
                    (_ctx.emptyOptions)
                        ? (_openBlock(), _createElementBlock("option", _hoisted_3, _toDisplayString(_unref($lang)('app.reservation.placeholder.select')), 1))
                        : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option) => {
                        return (_openBlock(), _createElementBlock("option", {
                            value: option[_ctx.valueField]
                        }, _toDisplayString(option[_ctx.labelField]), 9, _hoisted_4));
                    }), 256))
                ], 8, _hoisted_2), [
                    [_vModelSelect, field.value]
                ])
            ], 2));
        };
    }
});
